<app-responsive-popup [caption]="audio.text.diploma.thisisforyou" size="large">

  <div>
    <div class="diplomaSvg">
      <img [draggable]="false" src="/img/diploma.svg">
    </div>
    <div class="diploma-content">
      <div class="gebruikersnaam-wrapper">
        <div class="gebruikersnaam">
          <img [draggable]="false" class="gebruikersnaam-bg" src="/img/gebruikersnaam.svg">
          <div class="gebruikersnaam-content"><span>{{username}}</span></div>
        </div>
      </div>
      <div class="well-done">
        <span>Goed gespeeld! Je bent een kanjer!</span>
      </div>

    </div>
    <form (ngSubmit)="sendEmail()" #emailForm="ngForm" class="diploma-emailForm">

      <div class="form-caption"><span>{{audio.text.diploma.instruction}}</span></div>
      <div class="form-row">
        <div class="input-field">
          <input type="email" placeholder="{{audio.text.register.emailAddress}}" required [(ngModel)]="diplomaEmail"
            pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" #email="ngModel" id="email" name="email"
            (focus)="audio.play('register_voerjeemailadresin')">
        </div>

        <app-button size="small" color="secundairy" (click)="sendEmail(); audio.playSoundClick();"
          [disabled]="!emailForm.valid || state=='sending'">{{audio.text.diploma.send}}</app-button>
        <app-button size="small" color="secundairy" [disabled]="state=='sending'"
          (click)="Btn_closeEndScreen(); audio.playSoundClick();">{{audio.text.diploma.ready}}</app-button>
      </div>
      <!-- <button type="submit" class="button raised yellow" [disabled]="!emailForm.valid"
            [ngClass]="{'disabled': !emailForm.valid}" style="margin-left: 1em;">
            <span class="button_text">{{audio.text.diploma.send}}</span>
          </button> -->
    </form>


    <!-- <section > -->

    <!-- </section> -->

    <!-- <div class="next-wrap" style="margin-top: 4em !important">
          <span class="button green raised"
            (click)="Btn_closeEndScreen(); audio.playSoundClick();">{{audio.text.diploma.ready}}</span>
        </div> -->
  </div>



</app-responsive-popup>
